export const SUPPORTED_LOCALES = ['bg', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const isLocale = (value: unknown): value is Locale =>
  typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);

export type TranslationPrimitive = string | number | boolean | null;

export type TranslationValue =
  | TranslationPrimitive
  | TranslationPrimitive[]
  | TranslationRecord
  | TranslationValue[];

export type TranslationRecord = {
  [key: string]: TranslationValue;
};

export type TranslationDictionary = Record<Locale, TranslationRecord>;

export type TranslationPath<T extends TranslationValue = TranslationValue> = readonly string[] & {
  __value?: T;
};
